var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Role } from '../Model';
import history from 'helpers/History';
import { Table } from 'components';
import View from '../../../elements/View';
import { Button } from '../../../elements';
import Text from '../../../elements/Text';
import { T } from '../../../helpers/i18n';
var UsersTable = /** @class */ (function (_super) {
    __extends(UsersTable, _super);
    function UsersTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (user) {
            history.push("/users/".concat(user.id));
        };
        _this.handleCreate = function () {
            history.push("/users/create");
        };
        return _this;
    }
    UsersTable.prototype.componentDidMount = function () {
        this.props.store.users.read();
    };
    UsersTable.prototype.render = function () {
        var users = this.props.store.users;
        var headers = ['name', 'lastname', 'username', 'role', 'disabled_at', 'city', 'phone', 'email'];
        var filters = [
            {
                name: 'all',
                filter: function (item) { return true; }
            },
            {
                name: 'actives',
                filter: function (item) { return item.disabled_at === null; }
            },
            {
                name: 'disabled',
                filter: function (item) { return item.disabled_at !== null; }
            },
        ];
        return (React.createElement(View, null,
            React.createElement(Button, { style: {
                    marginTop: '25px',
                    marginLeft: '25px'
                }, onClick: function () { history.push('/users/logs'); } },
                React.createElement(Text, { primary: true }, T('logs'))),
            React.createElement(Table, { filters: filters, items: users.users.filter(function (user) { return user.role !== Role.Virtual; }), header: headers, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (user) { return String(user.id); }, loading: !users.loaded })));
    };
    UsersTable = __decorate([
        inject('store'),
        observer
    ], UsersTable);
    return UsersTable;
}(Component));
export default UsersTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Users/containers/UsersTable.tsx
// module id = 1245
// module chunks = 0